import React, { useContext, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import KaizenTable from "@kaizen-ui/table";
import { fetchMaintenanceList } from "../../api";
import { Layout } from "../../layout";
import Button, { ButtonGroup } from "@kaizen-ui/button";
import "./styles.css";

import AccessibilityContext from "../../components/auth/UserPermissionContext";
import WithAuth from "../../components/auth/WithAuth";
import WithAdminUIAuth from "../../components/auth/WithAdminUIAuth";
const Table = KaizenTable;

function formatUtcToReadable(dateStr) {
  if (!dateStr) return '';

  const date = new Date(dateStr + 'Z'); // Ensure UTC

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  const month = months[date.getUTCMonth()];
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();

  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  const time = `${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;

  return `${month} ${day}, ${year} ${time}`;
}



const MaintenanceList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [enablecreateMaintenance, setenableCreateMaintenance] = useState(false);
  const [pageIndex, setPage] = useState(0);
  const [pageSize, setSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sorting, setSorting] = useState([{ id: "modified_date", desc: true }]);
  const [filtering, setFiltering] = useState([{ id: "test", value: "test" }]);
  const [totalResults, setTotalResults] = useState(0);
  const [fetching, setFetching] = useState(true);

  const hiddenColumns = ["maintenanceid"];
  const columns = [
    { accessor: "maintenanceid", Header: "ID" },
    {
      accessor: "isNotice",
      Header: "Is Downtime",
      Cell: ({ value }) => value.toString()
    },
    {
      accessor: "isAnnouncement",
      Header: "Is Announcement",
      Cell: ({ value }) => value.toString()
    },
    {
      accessor: "fromdate",
      Header: "From Date",
      Cell: ({ value }) => value ? formatUtcToReadable(value) : "N/A",
    },
    {
      accessor: "todate",
      Header: "To Date",
      Cell: ({ value }) => value ? formatUtcToReadable(value) : "N/A",
    },
  ];
  
  
  const IsArrayEqual = (first, second) => {
    return JSON.stringify(second) === JSON.stringify(first);
  };

  const rowColorChange = (row) => {
    const roleid = row.roleid;
    if (roleid % 2 === 0) {
      return false;
    } else return true;
  };

  const handleFetchData = useCallback(
    (params) => {
      const insorting = JSON.stringify(params.sortBy);
      const inSortby = JSON.parse(insorting);
      const infiltering = JSON.stringify(params.filters);
      const inFilterBy = JSON.parse(infiltering);
      //console.log('currentPage : '+currentPage)
      if (IsArrayEqual(inSortby, sorting) === false) {
        //console.log('SortBY is not equal')
        setSorting(inSortby);
      }
      if (IsArrayEqual(inFilterBy, filtering) === false) {
        //console.log('Filter is not equal')
        setFiltering(inFilterBy);
      }
      if (
        pageIndex !== params.pageIndex + 1 &&
        currentPage !== params.pageIndex + 1
      ) {
        //console.log('before pageIndex :' + pageIndex)
        setPage(params.pageIndex + 1);
        //console.log('after pageIndex :' + pageIndex)
      }
      if (pageSize !== params.pageSize) {
        //console.log('before pageSize :' + pageIndex)
        setSize(params.pageSize);
      }
    },
    [currentPage, pageIndex, pageSize, sorting, filtering]
  );
  useEffect(() => {
  let isCancelled = false;

  const fetchData = async () => {
    if (pageIndex > 0) {
      setFetching(true);
      try {
        const data = await fetchMaintenanceList(pageIndex, pageSize, sorting, filtering);
        if (!isCancelled) {
          setData(data);
          setCurrentPage(pageIndex);
          setTotalPages(Math.ceil(data.length / pageSize));
          setTotalResults(data.length);
          setenableCreateMaintenance(data.length > 0);
        }
      } catch (error) {
        console.error("Error fetching maintenance list:", error);
        if (!isCancelled) {
          // You can set an error message to display on the UI
          setData([]); // or retain previous data
          setTotalPages(0);
          setTotalResults(0);
          setenableCreateMaintenance(false);
        }
      } finally {
        if (!isCancelled) {
          setFetching(false);
        }
      }
    }
  };

  fetchData();

  return () => {
    isCancelled = true; // Prevents state updates if component unmounts
  };
}, [pageIndex, pageSize, sorting, filtering, navigate]);


    return (
      <Layout
        key="layrole"
        title="Maintenance"
        headerChildren={
          <>
            <ButtonGroup key="btngrpcreaterole">

                <Button
                  key="btncreaterole"
                  icon={{ name: "ActionsCircleAdd", variant: "solid" }}
                  onClick={() => {
                    navigate("/maintenance/0");
                  }}
                  disabled={enablecreateMaintenance}
                >
                  Create Maintenance
                </Button>
              
            </ButtonGroup>
          </>
        }
      >
        <Table
          key="tblrole"
          initialState={{
            pageSize: pageSize,
            pageIndex: pageIndex,
            hiddenColumns: hiddenColumns,
          }}
          paginationPageSizeOptions={[
            { label: "5", value: 5 },
            { label: "10", value: 10 },
            { label: "25", value: 25 },
            { label: "50", value: 50 },
            { label: "100", value: 100 },
          ]}
          rowOnClick={({ values }) => navigate(`/maintenance/${values.maintenanceid}`)}
          columns={columns}
          data={data}
          pageCount={totalPages}
          totalResults={totalResults}
          fetchData={handleFetchData}
          fetching={fetching}
          autoResetPage={false}
          autoResetSortBy={false}
          disableColumnHiding={true}
          disableExport={false}
          disableGlobalFilter={true}
          //rowActions={getRowActionDetails}
          getRowProps={(row) => ({
            style: {
              background: rowColorChange(row) ? "" : "grey",
            },
          })}
        />
      </Layout>
    );

};

export default WithAuth(WithAdminUIAuth(MaintenanceList));
